export function formatTimeLocale(
  timeInput,
  {
    locale = navigator.language,
    hour = '2-digit',
    minute = '2-digit',
    second, // optional: can be '2-digit'
    hour12, // optional: force 12/24-hour format
    hourCycle, // optional: e.g., 'h23' (24h) or 'h12' (AM/PM)
    fallback = '', // return value if time is invalid
  } = {}
) {
  if (!timeInput) return fallback;

  let date;

  if (typeof timeInput === 'string') {
    const parts = timeInput.split(':').map(Number);
    if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1])) return fallback;

    date = new Date();
    date.setHours(parts[0], parts[1], parts[2] || 0);
  } else if (timeInput instanceof Date) {
    date = timeInput;
  } else {
    return fallback;
  }

  try {
    return new Intl.DateTimeFormat(locale, {
      hour,
      minute,
      ...(second ? { second } : {}),
      ...(hour12 !== undefined ? { hour12 } : {}),
      ...(hourCycle ? { hourCycle } : {}),
    }).format(date);
  } catch {
    return fallback;
  }
}
